import axios from '../../../shared/http/customAxios';

import dto from '../models/signupModel';
import dtoAddress from '../models/addressModel';

class SignupRepository {
	async submitStepOne(dto: dto) {
		try {
			const result = await axios().post('/user/register', dto);
			return result;
		} catch (error: any) {
			return error.response;
		}
	}

	async submitStepTwo(dto: dto) {
		try {
			const result = await axios().post('/user/register/2', dto);
			return result;
		} catch (error: any) {
			return error.response;
		}
	}

	async submitAddress(dto: dtoAddress) {
		try {
			const result = await axios().post('/user/register/address', {
				address: dto,
			});
			return result;
		} catch (error: any) {
			return error.response;
		}
	}

	async submitOffers(dto: dto) {
		try {
			const result = await axios().post('/user/register/offers', dto);

			return result;
		} catch (error: any) {
			return error.response;
		}
	}

	async preRegister(token: string) {
		try {
			const result = await axios().get(`/user/pre-register?token=${token}`, {
				headers: { noAuthorization: true },
			});
			return result;
		} catch (error: any) {
			return error.response;
		}
	}
}

export default SignupRepository;
